import { accountInit } from "@/redux/account.actions"
import { attributeInit } from "@/redux/attribute.actions"
import { userInit } from "@/redux/user.actions"
import { projectInit } from "@/redux/project.actions"
import { surveyInit } from "@/redux/survey.actions"
import { subscriptionInit } from "@/redux/subscription.actions"
import { templateInit } from "@/redux/template.actions"
import { topicInit } from "@/redux/topic.actions"
import { filterInit } from "@/redux/filter.actions"
import { questionInit } from "@/redux/question.actions"
import { sessionInit } from "@/redux/_session.actions"
import { propositionInit } from "@/redux/proposition.actions"
import { axisInit } from "@/redux/axis.actions"
import { bookmarkInit } from "@/redux/bookmark.actions"
import { learningInit } from "@/redux/learning.actions"
import { lessonInit } from "@/redux/lesson.actions"
import { regroupingInit } from "@/redux/regrouping.actions"
import { invitationInit } from "@/redux/invitation.actions"
import { sendingInit } from "@/redux/sending.actions"
import { reminderInit } from "@/redux/reminder.actions"
import { actionPlanInit } from "@/redux/action-plan.actions"
import { reportInit } from "@/redux/report.actions"
import { pageInit } from "@/redux/page.actions"
import { store } from "./root-reducer"

export const initReducers = () => {
  store.dispatch(sessionInit())
  store.dispatch(accountInit())
  store.dispatch(actionPlanInit())
  store.dispatch(axisInit())
  store.dispatch(attributeInit())
  store.dispatch(bookmarkInit())
  store.dispatch(filterInit())
  store.dispatch(learningInit())
  store.dispatch(lessonInit())
  store.dispatch(invitationInit())
  store.dispatch(pageInit())
  store.dispatch(propositionInit())
  store.dispatch(questionInit())
  store.dispatch(regroupingInit())
  store.dispatch(reminderInit())
  store.dispatch(reportInit())
  store.dispatch(sendingInit())
  store.dispatch(subscriptionInit())
  store.dispatch(surveyInit())
  store.dispatch(projectInit())
  store.dispatch(templateInit())
  store.dispatch(topicInit())
  store.dispatch(userInit())
}
